
const FAVICON_LOC = `${process.env.ASSETS_BUCKET_LOCATION}/cp-assets/favicon.png`;
const WINDOW_SCALE_FACTOR = '0.8';

export { FAVICON_LOC, WINDOW_SCALE_FACTOR };
